import type {
  HomeFaqBannerRow,
  HomeFaqContent,
  HomeFaqItem,
} from '../models/home-faq-content.model';
import { prepareFaqTitleHtml } from './home-faq-html.util';

const FAQ_ORDEN_CABECERA = 0;
const FAQ_NOMBRE_CABECERA = 'FAQ_CABECERA';

export function mapFaqBannersToContent(
  rows: HomeFaqBannerRow[],
  fallback: HomeFaqContent
): HomeFaqContent {
  const cabecera = rows.find((r) => esCabeceraFaq(r));
  const items = rows
    .filter((r) => !esCabeceraFaq(r) && Number(r.orden ?? 0) >= 1)
    .map((r) => mapPregunta(r))
    .filter((item): item is HomeFaqItem => item !== null)
    .sort((a, b) => a.orden - b.orden);

  return {
    eyebrow: (cabecera?.titulo ?? fallback.eyebrow).trim() || fallback.eyebrow,
    titleHtml: prepareFaqTitleHtml(
      (cabecera?.nombreBoton ?? fallback.titleHtml).trim() || fallback.titleHtml
    ),
    items,
  };
}

/** Home: órdenes exactos 1–5 (activas ya filtradas por API). */
export function takeHomeFaqItems(items: HomeFaqItem[]): HomeFaqItem[] {
  return items
    .filter((item) => item.orden >= 1 && item.orden <= 5)
    .sort((a, b) => a.orden - b.orden);
}

function esCabeceraFaq(row: HomeFaqBannerRow): boolean {
  const orden = Number(row.orden ?? -1);
  if (orden === FAQ_ORDEN_CABECERA) {
    return true;
  }
  const nombre = (row.nombreArchivo ?? '').trim().toUpperCase();
  return nombre === FAQ_NOMBRE_CABECERA;
}

function mapPregunta(row: HomeFaqBannerRow): HomeFaqItem | null {
  const orden = Number(row.orden ?? NaN);
  const pregunta = (row.titulo ?? '').trim();
  const respuesta = (row.contenido ?? '').trim();
  if (!Number.isFinite(orden) || orden < 1 || !pregunta) {
    return null;
  }
  return {
    idBanner: row.idBanner ?? null,
    orden,
    pregunta,
    respuesta,
  };
}
